import { RouteObject } from "react-router-dom";
import { DocumentLibrariesList } from "../pages/admin/document-libraries/DocumentLibrariesList";
import { DocumentLibraryCreate } from "../pages/admin/document-libraries/DocumentLibraryCreate";
import { DocumentLibraryDetail } from "../pages/admin/document-libraries/DocumentLibraryDetail";

export const documentLibrariesRoutes: RouteObject[] = [
  {
    id: "document-libraries-list",
    path: "",
    index: true,
    element: <DocumentLibrariesList />,
  },
  {
    id: "document-library-create",
    path: "create",
    element: <DocumentLibraryCreate />,
  },
  {
    id: "document-library-detail",
    path: ":id",
    element: <DocumentLibraryDetail />,
  },
];
